<template>
  <div>
    <TopNav/>
    <div class="container mt-4" >
      <div class="w-75 text-center mb-5">
        <h1 class="title">New Encounter</h1>
        <p>Select patient type to begin</p>
      </div>
      <div class="row w-100 justify-content-center patient-type-container ">
        <div class="card col-12 col-lg-5 mx-1 patient-type exist"  role="button" tabindex="0" @click="onExistingPatientClick" @keyup.enter="onExistingPatientClick">
          <i class="fas fa-search fs-4"></i>
          <h3>Existing patient</h3>
          <p>Search from patients records</p>
        </div>
        <div class="card col-12 col-lg-5 mx-1 patient-type new"  role="button" tabindex="0" @click="onNewPatientClick" @keyup.enter="onNewPatientClick">
          <i class="fas fa-user-plus fs-4"></i>
          <h3>New patient</h3>
          <p>Register new patient</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref ,computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import TopNav from '../layouts/topNav.vue'
import { useModalManager } from '@/composables/useModalManager'
import ExistingPatientModal from '@/components/modals/existingPatient.vue'
import NewPatientModal from '@/components/modals/newPatient.vue'
import { searchPatientService } from "@/services/api/patientService";

const { openAsPromise } = useModalManager()
const route = useRoute();
const ehrPatientName = route.query.ehrPatientName || ref('');
const ehrPatientDOB =  route.query.ehrPatientDOB|| ref('');
const patients = ref([]);                
const selectedPatientId = ref(null);     
const selectedPatient = computed(() =>
  patients.value.find(p => p.id === selectedPatientId.value) || null
);
// Update form fields when a patient is picked
watch(selectedPatient, (p) => {
  if (!p) return;
  ehrPatientName.value = p.name ?? "";
  ehrPatientDOB.value = p.date_of_birth ??"";
});

const searchPhone = async (query) => {
  try {
    const result = await searchPatientService(query);
    return result;
  } catch (err) {
    console.error(err);
  }
};
const onExistingPatientClick = async () => {
  const result = await openAsPromise({
    component: ExistingPatientModal,
    props: {
      fetchPatients: searchPhone,
    },
  })
  if (!result) return
}

const onNewPatientClick = async () => {
  const result = await openAsPromise({
    component: NewPatientModal,
  })
  if (!result) return
  console.log('Result:', result)
}
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 5rem;
}

.title {
  font-weight: 700;
  font-size: 3rem ;
  color: #518DB1 ;
}
.patient-type{
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 2rem;
  transition: box-shadow 0.5s ease-in-out;
}
.patient-type:hover {
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
}
.exist:hover {
  border: 2px solid #3c83f6;
}
.exist:hover h3 ,.exist i {
  color:  #3c83f6;
}
.exist i ,.new i{
  width: 5rem;
  height: 5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 2rem;
  font-size: 2rem !important;
}
.exist i{
  background-color: rgb(235 242 254);

}
.new i{
  background-color: rgb(235 251 250);

}
.new:hover {
  border: 2px solid #3ee0cf;
}
.new:hover h3 ,.new i {
  color:  #3ee0cf;
}

@media (max-width: 992px) {
  .patient-type-container {
    flex-direction: column;
  }
}
</style>
